import React, { useState, useEffect } from 'react';
import './FilterPopup.css';

const FilterPopup = ({ onClose, onApply, tableData, categories, getSearchResults }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredNames, setFilteredNames] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(categories[0] || '');
  const [categoryFilters, setCategoryFilters] = useState({});

  useEffect(() => {
    console.log('Search term:', searchTerm);
    console.log('Selected category:', selectedCategory);
    console.log('Has getSearchResults:', !!getSearchResults);
    console.log('TableData:', tableData);

    if (searchTerm && selectedCategory) {
      try {
        if (typeof getSearchResults === 'function') {
          const results = getSearchResults(searchTerm, selectedCategory);
          console.log('Search results:', results);

          if (Array.isArray(results)) {
            const filteredResults = results.filter(Boolean);
            console.log('Filtered results:', filteredResults);
            setFilteredNames(filteredResults);
          } else {
            console.warn('Search results are not in array format', results);
            // Fallback to basic filtering if getSearchResults doesn't work
            const filtered = tableData
              .map((item) => {
                switch (selectedCategory) {
                  case 'Technology ID':
                    return item.technology_id?.toString();
                  case 'Technology Name':
                    return item.technology_name;
                  case 'Description':
                    return item.description;
                  default:
                    return item[selectedCategory.toLowerCase()];
                }
              })
              .filter((value) => value && value.toLowerCase().includes(searchTerm.toLowerCase()));

            console.log('Fallback filtered results:', filtered);
            setFilteredNames(filtered);
          }
        } else {
          console.warn('getSearchResults is not a function, using fallback');
          // Same fallback logic as above
          const filtered = tableData
            .map((item) => {
              switch (selectedCategory) {
                case 'Technology ID':
                  return item.technology_id?.toString();
                case 'Technology Name':
                  return item.technology_name;
                case 'Description':
                  return item.description;
                default:
                  return item[selectedCategory.toLowerCase()];
              }
            })
            .filter((value) => value && value.toLowerCase().includes(searchTerm.toLowerCase()));

          console.log('Fallback filtered results:', filtered);
          setFilteredNames(filtered);
        }
      } catch (error) {
        console.error('Error in search:', error);
        setFilteredNames([]);
      }
    } else {
      setFilteredNames([]);
    }
  }, [searchTerm, selectedCategory, getSearchResults, tableData]);

  const handleSelectName = (name) => {
    if (selectedCategory) {
      const currentItems = categoryFilters[selectedCategory] || [];
      if (!currentItems.includes(name)) {
        setCategoryFilters({
          ...categoryFilters,
          [selectedCategory]: [...currentItems, name],
        });
      }
    }
  };

  const handleRemoveName = (name) => {
    if (selectedCategory) {
      const currentItems = categoryFilters[selectedCategory] || [];
      setCategoryFilters({
        ...categoryFilters,
        [selectedCategory]: currentItems.filter((item) => item !== name),
      });
    }
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSearchTerm(''); // Clear search input
    setFilteredNames([]); // Clear filtered results
  };

  const handleApplyFilters = () => {
    // Convert category filters to array format
    const allFilters = Object.entries(categoryFilters)
      .filter(([_, items]) => items && items.length > 0)
      .map(([category, items]) => ({
        category,
        items,
      }));

    if (allFilters.length > 0) {
      onApply(allFilters); // Send all filters to parent
    } else {
      console.error('No filters selected');
    }
  };

  return (
    <div className="filter-popup">
      <div className="popup-content">
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <div className="categories">
          <h3>Categories</h3>
          <ul>
            {categories.map((category) => (
              <li
                key={category}
                onClick={() => handleCategoryClick(category)}
                style={{
                  backgroundColor: selectedCategory === category ? 'gray' : 'transparent',
                  cursor: 'pointer',
                }}
              >
                {category}
              </li>
            ))}
          </ul>
        </div>

        <div className="search-column">
          <div className="search-input-wrapper">
            <div>
              <input
                type="text"
                placeholder={`Search by ${selectedCategory}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={!selectedCategory}
                style={{ width: '100%' }}
              />
            </div>
            {!selectedCategory && <div className="search-hint">Please select a category first</div>}
          </div>
          {searchTerm && (
            <div className="search-results">
              {filteredNames.length > 0 ? (
                <ul className="results-list">
                  {filteredNames.map((name) => (
                    <li key={name} onClick={() => handleSelectName(name)} className="result-item">
                      {name}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="no-results">No matches found</p>
              )}
            </div>
          )}
        </div>

        <div className="border-l border-gray-200 mx-4 my-2"></div>

        <div className="selected-items">
          <h3>Filter Selection</h3>
          {Object.entries(categoryFilters).map(([category, items]) =>
            items && items.length > 0 ? (
              <div key={category}>
                <h4>{category}</h4>
                <ul>
                  {items.map((item) => (
                    <li key={`${category}-${item}`}>
                      {item}
                      <button
                        onClick={() => {
                          setSelectedCategory(category);
                          handleRemoveName(item);
                        }}
                      >
                        x
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null,
          )}
        </div>

        {/* Bottom-right actions INSIDE popup-content */}
        <div className="filter-popup-actions">
          <button className="apply-btn" onClick={handleApplyFilters}>
            APPLY FILTERS
          </button>
          <button className="cancel-btn" onClick={onClose}>
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterPopup;
